import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='https://github.com/armemon'
      className='link footer__link'
      target="_blank"  rel="noreferrer"
    >
      Created By Abdul Rahman Memon
    </a>
  </footer>
)

export default Footer
